// Funciones puras de formato/cálculo usadas por ListadoSolicitud.js.
// No dependen de estado de React: misma entrada -> misma salida.
// Extraídas tal cual del componente, sin cambiar su lógica.

import { TIPO_FIRMA_ELECTRONICA, ESTADO_SOLICITUD, ESTADO_VERIFICACION_APROBADO } from "./ListadoSolicitud.constants";

// Cada proveedor de firma electrónica habilita el botón "Digital" en un
// Estado de solicitud distinto: Yupana solo cuando ya está FACTURADO, Banco
// Solidario desde que está APROBADO (su flujo de aprobación es independiente
// de la facturación) y también si llega a FACTURADO.
const ESTADOS_QUE_HABILITAN_FIRMA = {
  [TIPO_FIRMA_ELECTRONICA.YUPANA]: [ESTADO_SOLICITUD.FACTURADO],
  [TIPO_FIRMA_ELECTRONICA.BANCO_SOLIDARIO]: [ESTADO_SOLICITUD.APROBADO, ESTADO_SOLICITUD.FACTURADO],
};

export const puedeFirmarDigital = (data) => {
  const estadosHabilitados = ESTADOS_QUE_HABILITAN_FIRMA[data.TipoFirmaElectronica];
  if (!estadosHabilitados) return false;

  return (
    data.idEstadoVerificacionSolicitud === ESTADO_VERIFICACION_APROBADO &&
    estadosHabilitados.includes(data.Estado)
  );
};

export const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// función para calcular la diferencia de tiempo
export const calcularTiempoTranscurrido = (fechaInicial, fechaFinal) => {
  if (!fechaInicial || !fechaFinal) return "N/A";

  const inicio = new Date(fechaInicial);
  const fin = new Date(fechaFinal);

  // Si las fechas son inválidas
  if (isNaN(inicio.getTime()) || isNaN(fin.getTime())) return "N/A";

  const diferencia = fin - inicio;

  // Convertir milisegundos a días, horas, minutos
  const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
  const horas = Math.floor(
    (diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));

  if (dias > 0) {
    return `${dias}d ${horas}h ${minutos}min`;
  } else if (horas > 0) {
    return `${horas}h ${minutos}min`;
  } else {
    return `${minutos}min`;
  }
};

export const convertirTiempoASegundos = (tiempoStr) => {
  if (tiempoStr === "N/A") return 0;

  let segundos = 0;

  // Extraer días
  const diasMatch = tiempoStr.match(/(\d+)d/);
  if (diasMatch) {
    segundos += parseInt(diasMatch[1]) * 86400; // 1 día = 86400 segundos
  }

  // Extraer horas
  const horasMatch = tiempoStr.match(/(\d+)h/);
  if (horasMatch) {
    segundos += parseInt(horasMatch[1]) * 3600; // 1 hora = 3600 segundos
  }

  // Extraer minutos
  const minutosMatch = tiempoStr.match(/(\d+)min/);
  if (minutosMatch) {
    segundos += parseInt(minutosMatch[1]) * 60; // 1 minuto = 60 segundos
  }

  return segundos;
};

export const convertirSegundosATuFormato = (totalSegundos) => {
  if (totalSegundos === 0) return "0min";

  const dias = Math.floor(totalSegundos / 86400);
  const horas = Math.floor((totalSegundos % 86400) / 3600);
  const minutos = Math.floor((totalSegundos % 3600) / 60);

  let resultado = [];

  if (dias > 0) resultado.push(`${dias}d`);
  if (horas > 0) resultado.push(`${horas}h`);
  if (minutos > 0) resultado.push(`${minutos}min`);

  return resultado.join(" ") || "0min";
};
